'use client';

import { useMaintenanceBannerState } from '@app/_maintenanceBanner/useMaintenanceBannerState';
import { JSX } from 'react';

import { Close, WarningTriangle } from '@videoblocks/react-icons';

export default function MaintenanceBanner({
    message,
    endTime,
}: {
    message: string;
    endTime: Date;
}): JSX.Element | null {
    const { isDismissed, dismiss } = useMaintenanceBannerState(message, endTime);

    if (isDismissed) {
        return null;
    }

    return (
        <div
            role="alert"
            data-testid="maintenance-banner"
            className="flex w-full items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2"
        >
            <WarningTriangle className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
            <p className="flex-1 text-sm">{message}</p>
            <button
                type="button"
                onClick={dismiss}
                aria-label="Dismiss maintenance notification"
                className="p-1 hover:bg-blue-200 rounded transition-colors flex-shrink-0"
            >
                <Close className="w-5 h-5" aria-hidden="true" />
            </button>
        </div>
    );
}
